export const QikType = ({ props }) => ([
  { text: 'Qualitätsindikator (QI)', value: 'QI' },
  { text: 'Auffälligkeitskriterium (AK)', value: 'AK' },
  { text: 'Transparenzkennzahl (TKez)', value: 'TKez' },
  { text: 'Kalkulatorische Kennzahl (KKez)', value: 'KKez' },
  { text: 'Ergänzende Kennzahl (EKez)', value: 'EKez' },
  { text: 'Nebenkennzahl (NKez)', value: 'NKez' },
  { text: 'Merkmal', value: 'MERKMAL' },])
